import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Tooltip from "@mui/material/Tooltip";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import ScanditScanner from "../../../components/barcode/ScanditScanner/ScanditScanner";
import useAuth from "../../../hooks/useAuth";

export default function Filter({ className, filter, disabled, onChange }) {
  const { user } = useAuth();
  const [inputValue, setInputValue] = useState(filter.search);
  const [openScan, setOpenScan] = useState(false);

  useEffect(() => {
    setInputValue(filter.search || "");
  }, [filter.search]);

  const handleInputChange = event => {
    event.persist();
    setInputValue(event.target.value);
  };

  const handleInputKeyup = event => {
    event.persist();
    if (event.keyCode === 13) {
      onChange({ search: inputValue, page: 1 });
    }
  };

  const handleClear = () => {
    setInputValue("");
    onChange({ search: "", page: 1 });
  };

  const handleSearch = () => {
    onChange({ search: inputValue, page: 1 });
  };

  const handleToggleScan = () => {
    setOpenScan(v => !v);
  };

  const handleDetectedCode = (code) => {
    setInputValue(code);
    onChange({ search: code, page: 1 });
    setOpenScan(false);
  };

  return (
    <>
    <TextField
      name="assetSearch"
      fullWidth
      placeholder="Search"
      size="small"
      value={inputValue}
      disabled={disabled}
      onChange={handleInputChange}
      onKeyUp={handleInputKeyup}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {inputValue && (
              <IconButton onClick={handleClear} edge="end" sx={{ mr: 0.5 }}>
                <CloseIcon />
              </IconButton>
            )}
            {!disabled && (
              <Tooltip arrow title="Scan Barcode">
                <IconButton onClick={handleToggleScan} edge="end">
                  <QrCodeScannerIcon />
                </IconButton>
              </Tooltip>
            )}
          </InputAdornment>
        ),
      }}
    />
    {openScan && (
      <ScanditScanner
        onDetected={handleDetectedCode}
        onClose={handleToggleScan}
      />
    )}
    </>
  );
}

Filter.propTypes = {
  className: PropTypes.string,
};
